import en from './en';
import fa from './fa';

const translations = {
  en,
  fa,
};

export default translations;
